<template>
  <v-card
    light
    elevation="5"
    width="400px"
    tile
    outlined
    @mouseover="intoHoverAction"
    @mouseleave="outOfHoverAction"
  >
    <v-card-subtitle>サイトを選んでください</v-card-subtitle>
    <v-card-text scroll>
      <v-list max-height="70vh" class="overflow-y-auto">
        <v-list-item
          v-for="site in selectableSites"
          :key="`select_site_${site.siteKey}`"
          @click="transitionSelectSite(site.siteKey)"
        >
          <v-list-item-content>
            <v-list-item-title>{{ site.name }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list>
    </v-card-text>
  </v-card>
</template>

<script>
import { mapGetters } from 'vuex'
import {
  masterAdminPostsPathName,
  masterAdminSitesPathName
} from '@/src/routers/masterAdmin'

export default {
  name: 'SelectSiteContainer',
  computed: {
    ...mapGetters('UserAuthStore', ['selectableSites'])
  },
  destroyed () {
    this.outOfHoverAction()
  },
  methods: {
    transitionSelectSite (siteKey) {
      const routeName =
        this.inSiteManagement() && this.$route.name !== masterAdminSitesPathName
          ? this.$route.name
          : masterAdminPostsPathName
      this.$router
        .push({
          name: routeName,
          params: { siteKey: siteKey }
        })
        .catch(() => {})
      this.$emit('select-site', siteKey)
    },
    inSiteManagement () {
      const targetPath = this.$router.match({
        name: masterAdminSitesPathName
      }).path
      return this.$route.path.indexOf(targetPath) === 0
    },
    intoHoverAction () {
      document.documentElement.style.overflow = 'hidden'
    },
    outOfHoverAction () {
      document.documentElement.style.overflow = 'auto'
    }
  }
}
</script>
